import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseDns from '../../AbstractObjects/GatewayPlan/InnerPages/BaseDns';

const pageSchema = PlanGetSchema.pages.dns;
const pageId = pageSchema.pageId;

function PlanDns({
    planObject,
    setPlanData
}) {

    let pageData = planObject[pageId];

    return (
        <BaseDns
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanDns;